import * as React from 'react';
/**
 *
 * Original name: cloud done
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A378
 *
 */
export const CloudDonePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M44 24c0-7.626-4.374-12-12-12s-12 4.374-12 12c-7.626 0-12 4.374-12 12s4.374 12 12 12v-4c-5.458 0-8-2.542-8-8s2.542-8 8-8h4v-4c0-5.458 2.542-8 8-8s8 2.542 8 8v4h4c5.458 0 8 2.542 8 8s-2.542 8-8 8v4c7.626 0 12-4.374 12-12s-4.374-12-12-12Z", fill: "currentColor" }),
    React.createElement("path", { d: "m31 44.171-5.586-5.585-2.828 2.828L31 49.829l12.414-12.415-2.828-2.828L31 44.171Z", fill: "currentColor" })));
